import { useEffect } from 'react'
import { ACCOUNT_INITIALISE, LOGOUT } from '../../store/actions'
import { getDataService } from '../../services/back-end-service'
import {
  emptyLocalStorage,
  emptySessionStorage,
  getLocalStorage,
  setLocalStorage,
} from '../../utils/localStorage'
import { ACCESS_TOKEN } from '../../utils/constants'
import { isBo } from '../../utils/CommonMethods'
import { url } from '../../services/path-url'

export function useMultiTabLogout(dispatch) {
  useEffect(() => {
    const handleStorageEvent = (event) => {
      if (event.key === 'logout') {
        dispatch({ type: LOGOUT })
        emptyLocalStorage()
        emptySessionStorage()
      }
    }

    window.addEventListener('storage', handleStorageEvent)
    return () => window.removeEventListener('storage', handleStorageEvent)
  }, [dispatch])
}

export function useAuthInit(dispatch, onSuccessMenu) {
  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = isBo()
          ? getLocalStorage('ACCESS_TOKEN_BO')
          : getLocalStorage(ACCESS_TOKEN)

        if (!serviceToken) {
          dispatch({
            type: ACCOUNT_INITIALISE,
            payload: { isLoggedIn: false, user: null },
          })
          return
        }

        const menu = JSON.parse(getLocalStorage('menu'))
        const admin = JSON.parse(getLocalStorage('AdminMenu'))
        const entity = JSON.parse(getLocalStorage('entity'))
        const scope = JSON.parse(getLocalStorage('scope'))

        const entity_scope_table = JSON.parse(
          getLocalStorage('entity_scope_table')
        )
        const client_access = isBo()
          ? JSON.parse(getLocalStorage('clientAccess'))
          : {}

        if (entity === null)
          setLocalStorage('entity', JSON.stringify(menu.data.entity))
        if (scope === null)
          setLocalStorage('scope', JSON.stringify(menu.data.scope))
        if (entity_scope_table === null) {
          setLocalStorage(
            'entity_scope_table',
            JSON.stringify(menu.entity_scope)
          )
        }

        if (menu === null) {
          await getDataService(url.user.menu, onSuccessMenu)
        }

        const { user } = serviceToken
        dispatch({
          type: ACCOUNT_INITIALISE,
          payload: {
            isLoggedIn: true,
            user,
            menu,
            admin,
            entity,
            scope,
            client_access,
          },
        })
      } catch {
        dispatch({
          type: ACCOUNT_INITIALISE,
          payload: { isLoggedIn: false, user: null },
        })
      }
    }

    init()
  }, [])
}

